const summaryTextBase = {
    color: 'black.100',
    fontFamily: 'Inter',
    fontStyle: 'normal'
}

const summaryTextDefault = {
    ...summaryTextBase,
    fontSize: '16px',
    lineHeight: '25px',
    letterSpacing: '0.08px'
}

const summaryTotalLabel = {
    ...summaryTextDefault,
    fontWeight: '700'
}

const summaryTextTop = {
    ...summaryTextBase,
    fontSize: '14px',
    lineHeight: '22px',
    letterSpacing: '0.07px'
}

const weatherMessageBase = {
    padding: '15px',
    backgroundColor: 'peach.100',
    color: 'black.100',
    borderRadius: '3px',
    marginTop: '15px'
}

const heading = {
    fontFamily: 'cormorant',
    fontSize: '30px',
    fontWeight: '400',
    lineHeight: 'normal',
    color: 'black.100',
    fontStyle: 'normal'
}

const OrderSummaryStyles = {
    baseStyle: {
        heading,
        headingTop: {
            ...heading,
            fontWeight: '300'
        },
        summaryLabel: {
            ...summaryTextDefault,
            fontWeight: '300'
        },
        summaryLabelTop: {
            ...summaryTextTop,
            fontWeight: '300'
        },
        summaryPriceLabel: {
            ...summaryTextDefault,
            fontWeight: '400'
        },
        summaryPriceLabelTop: {
            ...summaryTextTop,
            fontWeight: '400'
        },
        summaryTotalLabel,
        summaryTotalLabelTop: {
            ...summaryTextTop,
            fontWeight: '700',
            color: 'teal.500'
        },
        mobileTotalPrice: {
            color: 'teal.500',
            fontFamily: 'Inter',
            fontSize: '14px',
            fontWeight: '700',
            fontStyle: 'normal'
        },
        mobileCloseLabel: {
            color: '#78726D',
            fontFamily: 'body',
            fontSize: '12px',
            fontWeight: '300',
            fontStyle: 'normal'
        },
        appliedPromotionTitle: {
            fontFamily: 'inter',
            fontSize: '16px',
            color: 'black.300',
            fontWeight: 400
        },
        appliedPromotionContent: {
            fontFamily: 'inter',
            fontSize: '16px',
            fontWeight: 300,
            color: 'black.300'
        },
        appliedPromotionRemoveButton: {
            fontSize: '14px',
            fontWeight: 300,
            fontFamily: 'inter',
            color: 'black.300',
            textDecoration: 'underline'
        },
        summaryContentWrapper: {
            '& .weather-msg': {
                fontSize: '16px'
            }
        },
        summaryDetailsWrapper: {
            '.weather-msg': {
                ...weatherMessageBase,
                fontSize: '16px'
            },
            marginTop: '15px'
        },
        summaryDetailsWrapperTop: {
            '.weather-msg': {
                ...weatherMessageBase,
                fontSize: '16px',
                marginTop: '3px'
            },
            paddingTop: '7px'
        },
        warningWrapper: {
            padding: '15px',
            backgroundColor: 'peach.100'
        },
        warningText: {
            color: 'black.100',
            fontSize: '16px',
            fontWeight: '400',
            letterSpacing: '0.08px'
        }
    }
}

export default OrderSummaryStyles
